/**
 * ABDM M3 consent constants — aligned with lims-ui.
 */

export const HI_TYPES_OPTIONS = [
  'Prescription',
  'DiagnosticReport',
  'DischargeSummary',
  'ImmunizationRecord',
  'HealthDocumentRecord',
  'WellnessRecord',
  'OPConsultation',
  'Invoice',
] as const;

/** Radiology-relevant defaults when opening the request drawer. */
export const DEFAULT_HI_TYPES: string[] = ['DiagnosticReport', 'HealthDocumentRecord'];

export const ABDM_CONSENT_PURPOSE = {
  CAREMGT: {
    code: 'CAREMGT',
    text: 'Care Management',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
  BTG: {
    code: 'BTG',
    text: 'Break the Glass',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
  PUBHLTH: {
    code: 'PUBHLTH',
    text: 'Public Health',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
  HPAYMT: {
    code: 'HPAYMT',
    text: 'Healthcare Payment',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
  DSRCH: {
    code: 'DSRCH',
    text: 'Disease Specific Healthcare Research',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
  PATRQT: {
    code: 'PATRQT',
    text: 'Self Requested',
    refUri: 'http://terminology.hl7.org/ValueSet/v3-PurposeOfUse',
  },
} as const;

export type ConsentPurpose = (typeof ABDM_CONSENT_PURPOSE)[keyof typeof ABDM_CONSENT_PURPOSE];

export function formatDateLocal(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function defaultFromDate(): string {
  const d = new Date();
  d.setMonth(d.getMonth() - 2);
  return formatDateLocal(d);
}

export function defaultToDate(): string {
  return formatDateLocal(new Date());
}

export function defaultExpiryDate(): string {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return formatDateLocal(d);
}

export function defaultExpiryTime(): string {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return d.toTimeString().slice(0, 5);
}
